import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LayoutOutlinedSvg from "@ant-design/icons-svg/es/asn/LayoutOutlined";
import AntdIcon from "../components/AntdIcon";
var LayoutOutlined = function LayoutOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LayoutOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LayoutOutlined.displayName = 'LayoutOutlined';
}
export default /*#__PURE__*/React.forwardRef(LayoutOutlined);